var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"label":_vm.mylabel,"id":_vm.id,"items":_vm.items,"error":_vm.error,"error-messages":_vm.error,"attach":"","filled":""},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})
}
var staticRenderFns = []

export { render, staticRenderFns }